import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  CreateProductLineItemDto,
  ProductLineItem,
  ProductTypeEnum,
  UpdateProductLineItemDto
} from '../../../api-client';
import { OrderService } from '../../../services/order.service';
import { TemplateService } from '../../../services/template.service';
import { ToastService } from '../../../services/toast.service';
import { Observable, map } from 'rxjs';
import { ProductService } from '../../../services/product.service';

export interface AddSWGSlotDTO {
  slot: number;
  productNumber?: string;
  create?: CreateProductLineItemDto;
}

export interface UpdateSWGSlotDTO {
  slot: number;
  update: UpdateProductLineItemDto;
}

@Component({
  selector: 'app-swg',
  templateUrl: './swg.component.html',
  styleUrls: ['./swg.component.scss']
})
export class SwgComponent implements OnInit {
  @Input()
  item!: ProductLineItem;

  @Input()
  index!: number;

  isExpanded = false;

  addModalOpen = false;

  templateName = '';
  createTemplateModal = false;

  fieldAmount$!: Observable<number | undefined>;

  labelProduct?: ProductLineItem;
  font: string = 'Arial';
  color: string = 'Black';

  slot9amount: number = 0;
  slot9amount2: number = 0;
  slot9amount3: number = 0;
  slotOptions9$!: Observable<any[]>;

  constructor(
    public readonly orderService: OrderService,
    public readonly translate: TranslateService,
    public readonly templateService: TemplateService,
    private readonly toastService: ToastService,
    public readonly productService: ProductService
  ) {
    this.fieldAmount$ = this.orderService.order$.pipe(
      map((o) => o?.lineItems.reduce((sum, curr) => (sum += curr.isField ? 1 : 0), 0))
    );
    this.ngOnChanges();
  }

  ngOnInit(): void {}

  ngOnChanges(changes?: SimpleChanges) {
    100;
    this.labelProduct = this.orderService.order$.value?.lineItems?.find(
      (l) => l.addedFrom && l.addedFrom.includes(this.item?.id) && l.isLabel
    );

    this.slotOptions9$ = this.productService.getSlot(18, ProductTypeEnum.Swg);
    // console.log(this.item);
    const slot9 = this.item?.set?.find((s) => s.slot == 18);
    this.slot9amount = slot9?.amount ?? 0;
    this.slot9amount2 = slot9?.amount2 ?? 0;
    this.slot9amount3 = slot9?.amount3 ?? 0;
  }

  removeField() {
    this.orderService.removeLineItem(this.item.id);
  }

  toggleIsExpanded() {
    this.isExpanded = !this.isExpanded;
  }

  addAddon(dto: AddSWGSlotDTO) {
    if (dto.productNumber) {
      this.orderService.addAddonProductByName(this.item.id, dto.productNumber);
    } else if (dto.create) {
      this.orderService.addAddonProduct(this.item.id, dto.create);
    }
  }

  removeAddon(slot: number) {
    this.orderService.removeAddonProduct(this.item.id, slot);
  }

  addSlot(dto: AddSWGSlotDTO) {
    if (this.item.set.some((prod) => prod.id == dto.create?.productId)) {
      this.toastService.displayToast({
        message: this.translate.instant('Configuration.AVK.Errors.AlreadyAdded'),
        time: 5000,
        type: 'danger'
      });
      return;
    }
    this.orderService.addLineItemSlot(this.item.id, dto.slot.toString(), dto.create as CreateProductLineItemDto);
  }

  updateSlot(dto: UpdateSWGSlotDTO) {
    this.orderService.updateLineItemSlot(this.item.id, dto.slot.toString(), dto.update);
  }

  removeSlot(slot: number) {
    if (!this.item.set.some((prod) => prod.slot == slot)) {
      this.toastService.displayToast({
        message: this.translate.instant('Configuration.AVK.Errors.AlreadyRemoved'),
        time: 5000,
        type: 'danger'
      });
      return;
    }
    this.orderService.removeLineItemSlot(this.item.id, slot.toString());
  }

  updateDoorHoles(options: any[], amount: number, amount2: number, amount3: number) {
    if (!options || options.length === 0) {
      console.warn('Keine Optionen vorhanden!', options);
      return;
    }

    if (amount === 0 && amount2 === 0 && amount3 === 0) {
      if (this.item.set.some((s) => s.slot == 18)) {
        this.orderService.removeLineItemSlot(this.item.id, '18'); // auch lineItemId übergeben
      }
      return;
    }

    const product = options[0]; // hier das SWG-Produkt

    this.orderService.addLineItemSlot(this.item.id, '18', {
      productId: product.id, // ICHTIG
      amount: Number(amount),
      amount2: Number(amount2),
      amount3: Number(amount3)
    });
  }
}
